import { Avatar, IconButton, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useRef, useState } from "react";
import ProfileMiniDropDown from "./ProfileMiniDropDown";
import { api } from "../../api/api";
import { signup_url } from "../../api/urls";
import { toast } from "react-toastify";
import objToFormdata from "../../components/ObjectFromdata";
import blank_img from "../../Assests/blank_delete.png";
import { useDispatch } from "react-redux";
import { updateProfileImage } from "../../Redux/Auth";

const ProfileImage = ({ image, user_id, refetch }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const handleOpenMenu = (e) => setAnchorEl(e.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const handleTriggerFilePicker = () => {
    fileInputRef.current?.click(); // open file picker
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const payload = {
        /* country_code:countryCode,***/

        profile_image: file,
      };
      const response = await api.patch(
        signup_url + `${user_id}/`,
        objToFormdata(payload)
      );
      dispatch(updateProfileImage(response.data.profile_image));
      refetch();

      toast.success("Profile image uploaded");

      // window.location.reload();
    } catch (error) {
      toast.error(error?.response?.data?.profile_image[0] || "Upload failed");
    }
  };

  const handleRemove = async () => {
    try {
      const defaultImageUrl = blank_img; // Image in /public folde
      const response = await fetch(defaultImageUrl);
      const blob = await response.blob();

      const file = new File([blob], "no-image.png", {
        type: blob.type,
      });
      await api.patch(
        signup_url + `${user_id}/`,
        objToFormdata({ profile_image: file })
      );
      dispatch(updateProfileImage(""));
      refetch();
      toast.success("Profile image removed");
    } catch (error) {
      toast.error("Remove failed");
    }
  };
  // sx={{ width: 60, height: 60 }}
  return (
    <Box position="relative">
      <Avatar
        src={image || ""}
        sx={{
          width: {
            xs: 60,
            sm: 70,
            md: 80,
            lg: 90,
          },
          height: {
            xs: 60,
            sm: 70,
            md: 80,
            lg: 90,
          },
        }}
      />

      <IconButton
        onClick={handleOpenMenu}
        size="small"
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,

          width: 20,
          height: 20,
          backgroundColor: "#fff",

          borderRadius: "50%",
          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
          p: "4px 5px",
          "&:hover": {
            backgroundColor: "#eee",
          },
        }}
      >
        <EditIcon fontSize="small" sx={{ p: "3px" }} />
      </IconButton>

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <ProfileMiniDropDown
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        // hasImage={!!image}
        //  hasImage={image && image !== blank_img}
        hasImage={image && !image.includes("blank_delete.png")}
        onAdd={handleTriggerFilePicker}
        onUpdate={handleTriggerFilePicker}
        onRemove={handleRemove}
      />
    </Box>
  );
};

export default ProfileImage;
